<template>
  <div class="app" >
    <!-- RACOURCIS -->

    <div class="text-xs-center">
       <v-bottom-sheet v-model="sheet">
         <v-list>
           <v-subheader>Menu Droit </v-subheader>
           <v-list-tile
             @click="sheet = false" >
             <v-list-tile-avatar>
               <v-avatar size="32px" tile>
                 <v-btn icon>
                   <v-icon>folder</v-icon>
                 </v-btn>
               </v-avatar>
             </v-list-tile-avatar>
             <v-list-tile-title  @click="sheet = false; dossier.etat = true; dossier.title='Créer';  dossier.libelle = ''; dossier.description = ''; dossier.id = ''  ">Nouveau Dossier</v-list-tile-title>
           </v-list-tile>
           <v-list-tile
             @click="sheet = false"   >
             <v-list-tile-avatar>
               <v-avatar size="32px" tile>
                 <v-btn icon>
                   <v-icon>backup</v-icon>
                 </v-btn>
               </v-avatar>
             </v-list-tile-avatar>
             <v-list-tile-title @click="televersement = true; folder=false; lancement();">Importer des Fichiers</v-list-tile-title>
           </v-list-tile>
         </v-list>
       </v-bottom-sheet>
     </div>

     <div class="text-xs-center">
        <v-bottom-sheet v-model="edit">
          <v-list>
            <v-subheader>{{dossier.libelle}}</v-subheader>
            <v-list-tile
              @click="edit = false">
              <v-list-tile-avatar>
                <v-avatar size="32px" tile>
                  <v-btn icon>
                    <v-icon>folder_open</v-icon>
                  </v-btn>
                </v-avatar>
              </v-list-tile-avatar>
              <v-list-tile-title  @click="naviguateFolder()">Ouvrir le repertoire</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              @click="edit = false" v-if="currentFolder.admin == user.email">
              <v-list-tile-avatar>
                <v-avatar size="32px" tile>
                  <v-btn icon>
                    <v-icon>share</v-icon>
                  </v-btn>
                </v-avatar>
              </v-list-tile-avatar>
              <v-list-tile-title  @click="shareFolderInit()">Partager le repertoire</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              @click="edit = false"  v-if="currentFolder.admin == user.email">
              <v-list-tile-avatar>
                <v-avatar size="32px" tile>
                  <v-btn icon>
                    <v-icon>mode_edit</v-icon>
                  </v-btn>
                </v-avatar>
              </v-list-tile-avatar>
              <v-list-tile-title  @click="edit = false; dossier.etat = true; dossier.title='Modifier'">Modifier le repertoire</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              @click="edit = false"  v-if="currentFolder.admin == user.email">
              <v-list-tile-avatar>
                <v-avatar size="32px" tile>
                  <v-btn icon>
                    <v-icon>delete_forever</v-icon>
                  </v-btn>
                </v-avatar>
              </v-list-tile-avatar>
              <v-list-tile-title  @click="removeF('folder');">Supprimer le repertoire</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-bottom-sheet>
      </div>

      <div class="text-xs-center">
         <v-bottom-sheet v-model="currentFichier.etat">
           <v-list>
             <v-subheader>{{currentFichier.libelle}}</v-subheader>
             <v-list-tile
               @click="lecture()" >
               <v-list-tile-avatar>
                 <v-avatar size="32px" tile>
                   <v-btn icon>
                     <v-icon>zoom_in</v-icon>
                   </v-btn>
                 </v-avatar>
               </v-list-tile-avatar>
               <v-list-tile-title>Lire le fichier</v-list-tile-title>
             </v-list-tile>
             <v-list-tile
               @click="shareFilesInit()" v-if="currentFichier.admin == user.email">
               <v-list-tile-avatar>
                 <v-avatar size="32px" tile>
                   <v-btn icon>
                     <v-icon>share</v-icon>
                   </v-btn>
                 </v-avatar>
               </v-list-tile-avatar>
               <v-list-tile-title>Partager le fichier</v-list-tile-title>
             </v-list-tile>
             <v-list-tile
               @click="removeF('fichier');" v-if="currentFichier.admin == user.email">
               <v-list-tile-avatar>
                 <v-avatar size="32px" tile>
                   <v-btn icon>
                     <v-icon>delete_forever</v-icon>
                   </v-btn>
                 </v-avatar>
               </v-list-tile-avatar>
               <v-list-tile-title>Supprimer le fichier</v-list-tile-title>
             </v-list-tile>
           </v-list>
         </v-bottom-sheet>
       </div>

     <v-dialog
        v-model="televersement"
        fullscreen
        transition="dialog-bottom-transition"
        :overlay=false
        scrollable
      >
        <v-card>
            <v-toolbar style="flex: 0 0 auto;" dark class="primary">
            <v-btn icon @click.native="televersement = !televersement; load()" dark>
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Envoyer des fichiers </v-toolbar-title>
            <v-spacer></v-spacer>

          </v-toolbar>
            <v-layout row>
                <v-flex xs12>
                <el-upload
                  class="upload-demo"
                  drag
                    :action="upload"
                  multiple>
                  <i class="el-icon-upload"></i>
                </el-upload>
              </v-flex>
              <br>
            </v-layout>
        </v-card>
      </v-dialog>

  <v-layout row>
    <v-flex xs12 sm12  v-loading="loading"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" >
      <v-card  @contextmenu.prevent="sheet = true" >
        <section>
        <v-list two-line >

            <!-- LISTE DES DOSSIERS PARTAGES -->
              <v-subheader inset>Dossiers partagés</v-subheader>
              <v-divider inset></v-divider>
              <v-layout row wrap>
                  <v-flex xs3  v-for="item in dossierPartage" >
                  <v-list-tile avatar  @click="editFolder(item)">
                    <v-list-tile-avatar>
                      <v-icon class="grey lighten-1 white--text">folder</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ item.libelle }}
                      <v-icon v-if="item.admin == user.email" style="color:#F00">verified_user</v-icon>
                    </v-list-tile-title>
                      <v-list-tile-sub-title>{{ item.date }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
              </v-layout>

              <!-- LISTE DES FICHIERS PARTAGES -->
              <v-subheader inset>Fichiers partagés</v-subheader>
              <v-divider inset></v-divider>
              <v-layout row wrap>
            
                  <v-flex xs3  v-for="item in fichierPartage" >
                  <v-list-tile avatar  @click="editFile(item)">
                    <v-list-tile-avatar>
                      <v-icon class="blue white--text">assignment</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ item.libelle }}
                      <v-icon v-if="item.admin == user.email" style="color:#F00">verified_user</v-icon>
                    </v-list-tile-title>
                      <v-list-tile-sub-title>{{ item.date }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
              </v-layout>

            <div v-if="currentFolder.parent">

              <v-subheader inset>Dossier parent</v-subheader>
                <v-divider inset></v-divider>
                <v-list-tile avatar  @click=""  @dblclick.native="parentFolder()" style="width:100px; margin-left: 60px;">
                  <p>...</p>
                </v-list-tile>
              </div>

                <!-- LISTE DES DOSSIERS NON PARTAGES -->
                <v-subheader inset>Dossiers</v-subheader>
                <v-divider inset></v-divider>
                <v-layout row wrap>
                  <v-flex xs3  v-for="item in dossiers" >
                  <v-list-tile avatar  @click="editFolder(item)">
                    <v-list-tile-avatar>
                      <v-icon class="grey lighten-1 white--text">folder</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ item.libelle }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ item.date }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
              </v-layout>

              <!-- LISTE DES FICHIERS -->
              <v-subheader inset>Fichiers</v-subheader>
              <v-divider inset></v-divider>
               <v-layout row wrap>
                <v-flex xs3  v-for="item in fichiersansNom" >
                  <v-list-tile avatar  @click="editFile(item)">
                    <v-list-tile-avatar>
                      <v-icon class="blue white--text">assignment</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ item.libelle }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ item.date }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                </v-layout>
                </v-list>

            </section>
              </v-card>
            </v-flex>
          </v-layout>

          <!-- MODAL PARTAGER DOSSIER -->
          <el-dialog
              :title=" 'Partager le dossier ' + currentFolder.libelle + ' avec:'"
              :visible.sync="dialogShareFolder"
              width="50%"
              center>
              <v-form v-model="sendFolder" ref="form" lazy-validation id="sendFolder">
              <span>
                  <el-transfer
                         :titles="['Les utilisateurs', 'Selectionne']"
                         filterable
                         filter-placeholder="Rechercher" style="width: 100%"
                         v-model="folderGroupe.selection"
                         :data="folderGroupe.liste">
                  </el-transfer>
                <v-btn icons color="blue" @click="submitShareFolder" dark style="float:right; margin-top: -25px">Partager</v-btn>
              </span>
              <span slot="footer" class="dialog-footer">
              </span>
              </v-form>
          </el-dialog>

          <!-- MODAL PARTAGER FICHIER -->
          <el-dialog
              :title=" 'Partager le fichier ' + currentFichier.libelle + ' avec:'"
              :visible.sync="dialogShareFile"
              width="50%"
              center>
              <v-form v-model="sendFile" ref="form" lazy-validation id="sendFile">
              <span>
                  <el-transfer
                         :titles="['Les utilisateurs', 'Selectionne']"
                         filterable
                         filter-placeholder="Rechercher" style="width: 100%"
                         v-model="groupe.selection"
                         :data="groupe.liste">
                  </el-transfer>
                <v-btn icons color="blue" @click="submitShareFile" dark style="float:right; margin-top: -25px">Partager</v-btn>
              </span>
              <span slot="footer" class="dialog-footer">
              </span>
              </v-form>
          </el-dialog>

          <v-dialog v-model="dossier.etat" max-width="300px" persistent>
             <v-card>
               <v-card-title>
                 Nouveau Dossier
               </v-card-title>
               <v-card-text>
                 <div v-if="erreur.type">
                   <el-alert
                     :title="erreur.message"
                     type="error"
                     >
                  </el-alert>
                 </div>

                <v-form ref="form" lazy-validation>
                 <v-text-field
                    label="Nouveau Dossier"
                    v-model="dossier.libelle"
                    :rules="dossier.nameRules"
                    required
                  ></v-text-field>
                </v-form>
               </v-card-text>
             <v-card-actions>
               <v-btn color="primary" flat @click.stop="dossier.etat = !dossier.etat" >Annuler</v-btn>
               <v-btn color="primary" dark @click="valideCreate" >{{dossier.title}}</v-btn>
               </v-card-actions>
             </v-card>
          </v-dialog>

  </div>
</template>

<script>
  export default {
    name: 'app',
    data () {
      return {
        domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
        userCon: JSON.parse(sessionStorage.getItem('userInfo')),
        roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
        parent:true,
        groupe:{selection:[],liste:[]},
        folderGroupe:{selection:[],liste:[]},
        edit:false,
        currentFolder:{id:null, libelle:'', folder:[], fichiers:[], parent:'' , parentID:'' , admin:''},
        upload:'',
        sendFile:'',
        sendFolder:'',
        folder:false,
        dialogShareFolder: false,
        dialogShareFile: false,
        erreur:{message:'', type:false},
        televersement:false,
        sheet: false,
        loading:false,
        allUser: [],
        allUserFolderSelected: [],
        allUserFile: [],
        allUserFileSelected: [],
        allUserShared: [],
        dossierPartage: [],
        fichierPartage: [],
        valid: true,
        checkbox: false,
        dossiers:[],
        user: JSON.parse(sessionStorage.getItem('userInfo')),
        viewMenu: false,
        currentFichier:{etat:false, libelle:'', admin:''},
        dossier:{id:'', libelle:'Dossier sans titre', description:'', etat:false, title:'',
        nameRules: [
          (v) => !!v || 'libelle requis'
        ],
      },
      items2:[],
        dialog: false,
        fichiersansNom:[],
          ctxFocus:null,
      }
    },

    mounted () {
      this.load();
      this.currentFolder.id = null;
    },
    methods: {
      removeF(item){
        let url = ""
        var formdata = new FormData();
            if(item == "folder"){
               url = this.domaine +  'webservice/drive/remove/folder'
               formdata.append('id', this.dossier.id)
            }else{
               url = this.domaine +  'webservice/drive/remove/fichier'
               formdata.append('id', this.currentFichier.id)
            }

              this.$confirm('Etes vous sur de vouloir supprimer l\'element ?')
            .then(_ => {

              this.loading = true;

              formdata.append('user', this.user.id)

              this.$http.post(url, formdata).then(response => {
                if (response.body) {
                  this.loading = false;
                    if(response.body.code == 2){
                      window.location.reload(true)
                      this.currentFichier.etat = false
                    }else{

                    }
                }
              })

            })
            .catch(_ => {});

      },
      submitShareFolder(){

        this.loading = true;
        let url = this.domaine +  'webservice/drive/share-docs-user'
        var formdata = new FormData();
        this.folderGroupe.selection.forEach(function(item){
            formdata.append('data[]', item)
        });
        formdata.append('dossierId', this.dossier.id)
        formdata.append('userId', this.user.id)
        this.$http.post(url, formdata).then(response => {
          if (response.body) {
            if (response.body.code === 1) {
              this.$notify({
                title: 'LE DOSSIER A BIEN ETE PARTAGE',
                message: 'Partage réussie avec succès.',
                type: 'success',
                position: 'top-center'
              })
              this.loading = false;
              this.dialogShareFolder = false;
              window.location.reload(true)
            } else {
              this.$message.error(response.body.message)
            }
          }
        })
      },
      submitShareFile(){

        this.loading = true;
        let url = this.domaine +  'webservice/drive/share-file-user'
        var formdata = new FormData();
        this.groupe.selection.forEach(function(item){
            formdata.append('data[]', item)
        });
        formdata.append('fileId', this.currentFichier.id)
        formdata.append('fileLibelle', this.currentFichier.libelle)
        formdata.append('userId', this.user.id)
        this.$http.post(url, formdata).then(response => {
          if (response.body) {
            if (response.body.code === 1) {
              this.$notify({
                title: 'LE FICHIER A BIEN ETE PARTAGE',
                message: 'Partage réussie avec succès.',
                type: 'success',
                position: 'top-center'
              })
              this.loading = false;
              this.dialogShareFile = false;
              window.location.reload(true)
            } else {
              this.$message.error(response.body.message)
            }
          }
        })
      },
      shareFilesInit(){
        this.dialogShareFile = true
        this.currentFichier.etat = false
        this.loadUserFiles()
      },  
      shareFolderInit(){
        this.dossier.title = 'Partager'
        this.dialogShareFolder = true
        this.loadUser()
      },
      editFile(item){
          this.currentFichier.etat = true
          this.currentFichier.url = item.url 
          this.currentFichier.id = item.id 
          this.currentFichier.admin = item.admin 
          this.currentFichier.libelle = item.libelle
      },
      editFolder(item){
          this.edit = true;
          this.dossier.id = item.id
          this.currentFolder.id = item.id
          this.currentFolder.admin = item.admin
          this.dossier.libelle = item.libelle
          this.dossier.description = item.description
      },
      parentFolder(){
          if(this.currentFolder.parent == true){
              this.currentFolder.id = this.currentFolder.parentID
          }else{
              this.currentFolder.id = null
          }
          this.load();
      },
      naviguateFolder(){
      this.parent = false;
      this.folder = true;
      this.load();

      },
      lecture(){
          window.open(this.currentFichier.url,'_blank');
      },
      lancement(){
        if(this.currentFolder.id == null){
          this.upload = this.domaine +  'webservice/drive/file/add/' + this.user.id;
        }else{
            this.upload = this.domaine +  'webservice/drive/file/add/' + this.user.id + '/'+this.currentFolder.id;
        }

      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      loadUserFiles(){
        this.groupe.liste = [];
        this.groupe.selection = [];
        this.loading = true;
        let url = this.domaine +  'webservice/drive/load-user-files'
        var formdata = new FormData();
        formdata.append('user', this.user.id)
        formdata.append('fichierId', this.currentFichier.id)
        formdata.append('userId', this.user.id)
        this.$http.post(url, formdata).then(response => {
          if (response.body) {
            this.allUserFile = response.body[0]
            this.allUserFileSelected = response.body[1]
            this.loading = false;
            self = this
            this.allUserFile.forEach(function(item){
                self.groupe.liste.push({
                  label: item.name,
                  key: item.id
                });
            })
            this.allUserFileSelected.forEach(function(item){
                self.groupe.selection[item.id] = item.id;
            })
          }
        })
      },
      loadUser(){
        this.folderGroupe.liste = [];
        this.folderGroupe.selection = [];
        this.loading = true;
        let url = this.domaine +  'webservice/drive/load-user'
        var formdata = new FormData();
        formdata.append('user', this.user.id)
        formdata.append('dossierId', this.currentFolder.id)
        formdata.append('userId', this.user.id)
        this.$http.post(url, formdata).then(response => {
          if (response.body) {
            this.allUser = response.body[0]
            this.allUserFolderSelected = response.body[1]
            this.loading = false;
            self = this
            this.allUser.forEach(function(item){
                self.folderGroupe.liste.push({
                  label: item.name,
                  key: item.id
                });
            })
            this.allUserFolderSelected.forEach(function(item){
               self.folderGroupe.selection[item.id] = item.id;
            })
          }
        })
      },
      load(){
        this.loading = true;
        let url = this.domaine +  'webservice/drive/'
        var formdata = new FormData();
        formdata.append('user', this.user.id)
        formdata.append('id', this.currentFolder.id)
        this.$http.post(url, formdata).then(response => {
          if (response.body) {
            this.fichierPartage = response.body[2]
            this.dossierPartage = response.body[1]
            this.dossiers = response.body[0].data
            this.fichiersansNom = response.body[0].fiche
            this.currentFolder.parent = response.body[0].parent
            this.currentFolder.parentID = response.body[0].parentID
            this.loading = false;
          }
        })

      },
      valideCreate(){
        this.erreur.type = false;
        this.loading = false;
          if (this.$refs.form.validate()) {
            this.loading = true;
            var formdata = new FormData();
            formdata.append('dossier[libelle]', this.dossier.libelle)
            formdata.append('dossier[user]', this.user.id)
            formdata.append('dossier[id]', this.dossier.id)
            formdata.append('dossier[description]', this.dossier.description)
            formdata.append('dossier[etat]', this.dossier.etat)
            formdata.append('dossier[folder]',  this.currentFolder.id)
            let url = this.domaine + 'webservice/drive/dossier/add'
            this.$http.post(url, formdata).then(response => {
              if (response.body.code == 1) {
                this.dossier.etat = false;
                this.load();
              }else{
                this.loading = false;
                this.erreur.type = true;
                this.erreur.message = response.body.message;
              }
            },
            response => {
            })

          }
      },
       beforeMount: function () {
        if(!this.roleAcces[this.$router.history.current.name]){
          this.$router.push({ name: 'Home'  })
        }
    }

    }
  }
</script>

<style media="screen">

  .el-upload-dragger, .el-upload{
    width: 100%!important;
    height: 450px;
  }

  .shName, .shCheckbox {
    display:inline-block
  }

  .shName{
    top:-25px;
    position:relative;
  }

</style>



// WEBPACK FOOTER //
// src/components/Drive.vue